const { default: Hero } = require('../Hero/Hero');

const Home = () => {
	return <Hero />;
};

export default Home;
